module.exports = __webpack_public_path__ + "img/male.e2a8b23a.png";